import api from './api';

export const reportsAPI = {
  getCurrentPeriod: () => api.get('/api/reports/meta/current-period'),
  getWeeklyBatchHealth: (params) => api.get('/api/reports/weekly/batch-health', { params }),
  getWeeklyTeacherHealth: (params) => api.get('/api/reports/weekly/teacher-health', { params }),
  getWeeklyTeacherDetail: (teacherId, params) =>
    api.get(`/api/reports/weekly/teacher-health/${teacherId}`, { params }),
  getWeeklyPendingItems: (params) => api.get('/api/reports/weekly/pending-items', { params }),
  getWeeklyClassStartPunctuality: (params) =>
    api.get('/api/reports/weekly/class-start-punctuality', { params }),
  getMonthlySummary: (params) => api.get('/api/reports/monthly/summary', { params }),
  getMonthlyTeacherPerformance: (params) => api.get('/api/reports/monthly/teacher-performance', { params }),
  getMonthlyTeacherRetention: (params) => api.get('/api/reports/monthly/teacher-retention', { params }),
  getMonthlyTeacherRetentionDetail: (teacherId, params) =>
    api.get(`/api/reports/monthly/teacher-retention/${teacherId}`, { params }),
  getMonthlyBatchPerformance: (params) => api.get('/api/reports/monthly/batch-performance', { params }),
  getMonthlyStudentAttendance: (params) => api.get('/api/reports/monthly/student-attendance', { params }),
  getMonthlyDemos: (params) => api.get('/api/reports/monthly/demos', { params }),
};

export default reportsAPI;
